__turbopack_context__.v({
  "root": "index-module__o6FjtG__root",
});
